module.exports = __webpack_public_path__ + "static/media/pass-2-bw.c55ddbc1.png";